import React from 'react';
import {css} from 'emotion';


const ButtonEasy = (props) =>{
  return(
    <div
      onClick={props.onPress}
      className={css`
            background-color:${props.color?props.color:'#0086C8'};
            display:inline-block;
            width:${props.width};
            height:${props.height}px;
            text-align:center;
            padding:10px;
            color:white;
            box-sizing:border-box;
            border-radius:10px;
            cursor:pointer;
            &:hover{
              background-color:${props.hoverColor?props.hoverColor:'#4596bf'}
            }`}>
      {props.text}
    </div>
  )
}

export default ButtonEasy
